<template>
  <div class="custom-header">
    <span>{{ label }}</span>
    <div v-if="isRegisterView">
      <EmployeeFilter
        :current-folder="currentViewFolder"
        :register-view="isRegisterView"
        :filters-data="filtersData"
        :filtered-emp="filteredAttendanceSummary"
        :selected-emp="selectedEmployee"
        :on-grid-ready="onGridReady"
        :update-filter-values="updateFilterValues"
        @update-selected-employee="updateSelectedEmployee"
      />
    </div>
    <div :class="isRegisterView ? 'right-position' : 'left-position'">
      <WfmDateSwitcher
        :is-week-picker="isWeekPicker"
        :grid-data-source="filtersData"
        :is-render-complete="monthChangeBtnControl"
        @update-month-year="updateMonthYear"
      />
    </div>
    <div class="business-filter">
      <WfmBusinessFilter
        :folder="currentViewFolder"
        @apply-businesses-filter="updateFilterValues"
      />
    </div>
    <div
      class="actions"
    >
      <label v-if="gridView === 'attendance'">
        <input
          type="checkbox"
          :checked="isRegisterView"
          @change="showRegisterView($event)"
        >
        <span
          style="font-size: 12px"
        >Show Register View</span>
      </label>
      <label v-if="gridView === 'attendance' && !isRegisterView">
        <input
          type="checkbox"
          @change="showInOut($event)"
        >
        <span
          style="font-size: 12px"
        >Show in/out time</span>
      </label>
      <div class="action-container">
        <div
          v-if="!isRegisterView && allowRowRemove"
          class="action-button"
          @click="removeEmptyRows"
        >
          <button>
            Remove row
          </button>
        </div>
        <div
          class="action-button"
          @click="clearSelections"
        >
          <button>
            Deselect all
          </button>
        </div>
        <div
          v-if="isApprovalManager && gridView === 'allocations'"
          class="action-button"
          @click="deleteAllocations"
        >
          <button>
            Delete Cell
          </button>
        </div>
        <div
          v-if="isApprovalManager && gridView === 'attendance'"
          class="action-button"
          @click="approveAttendanceCells"
        >
          <button>
            Approve
          </button>
        </div>
        <div
          v-if="isApprovalManager && gridView === 'attendance'"
          class="action-button"
          @click="rejectAttendanceCells"
        >
          <button>
            Reject
          </button>
        </div>
        <div
          v-if="isPeUnapproveUser && gridView === 'attendance'"
          class="action-button"
          @click="unapproveAttendanceCells"
        >
          <button>
            Unapprove
          </button>
        </div>
        <div
          class="action-save"
          @click="saveChanges"
        >
          <button>
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="isRegisterView"
    :style="{float: 'right', width: '25%', height: '200px', 'margin-top': '4vh'}"
  >
    <RegisterSummary
      :current-folder="currentViewFolder"
      :filtered-emp="filteredAttendanceSummary"
      :on-grid-ready="onGridReady"
      :selected-emp="selectedEmployee"
      :register-view="isRegisterView"
      :show-pending-only="showPendingOnly"
      :show-approved-only="showApprovedOnly"
      :update-filter-values="updateFilterValues"
      @toggle-pending-work="togglePendingWork"
      @toggle-approved-work="toggleApprovedWork"
      @update-search-query="updateSearchQuery"
      @update-selected-employee="updateSelectedEmployee"
      @update-selected-employee-type="updateSelectedEmployeeType"
    />
    <div class="text-left ms-2">
      <div class="leaves-left">
        This Month Leaves Left : <span>{{ leaveQuota?.leaves_left }}</span>
      </div>
      <div class="leaves-left">
        Yearly Leaves Left : <span>{{ leaveQuota?.yearly_leaves_left }}</span>
      </div>
    </div>
  </div>
  <div
    v-else
  >
    <FilterComponent
      :current-folder="currentViewFolder"
      :filters-data="filtersData"
      :on-grid-ready="onGridReady"
      :update-filter-values="updateFilterValues"
      :clear-selection="clearSelection"
    />
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import postData from '../../../composables/postData';
import getFatRow from '../../../composables/fatRowGenerator';

import WfmDateSwitcher from '../../../common/wfm-dateSwitcher.vue';
import FilterComponent from './FilterComponent.vue';
import RegisterSummary from './RegisterSummary.vue';
import EmployeeFilter from './EmployeeFilter.vue';
import { useStore } from 'vuex';
import attendanceGridUtils from '../../../composables/attendanceGridUtils';
import allocationGridUtils from '../../../composables/allocationGridUtils';
import { toast } from 'vue3-toastify';
import WfmBusinessFilter from '../../../common/wfm-business-filter.vue'
import getFolders from '../../../composables/getFolders';
import { sendMessage } from '../../../services/websocket.js';
export default {
  components: { WfmDateSwitcher, FilterComponent, RegisterSummary, EmployeeFilter, WfmBusinessFilter},
  props: {
    currentFolder: {
      type: Object,
      default: () => {}
    },
    isDutyChart: {
      type: Boolean,
      default: () => false
    },
    registerView: {
      type: Boolean,
      default: () => false
    },
    filtersData: {
      type: Object,
      default: () => {}
    },
    selectedCells: {
      type: Object,
      default: () => {}
    },
    onGridReady: {
      type: Function,
      default: () => {}
    },
    showInOutToggle: {
      type: Function,
      default: () => {}
    },
    updateFilterValues: {
      type: Function,
      default: () => {}
    },
    clearSelection: {
      type: Function,
      default: () => {}
    },
    clearWeeklySelection: {
      type: Function,
      default: () => {}
    },
    approveWeeklySelection: {
      type: Function,
      default: () => {}
    },
    rejectWeeklySelection: {
      type: Function,
      default: () => {}
    },
    unapproveWeeklySelection: {
      type: Function,
      default: () => {}
    },
    saveWeeklySelection: {
      type: Function,
      default: () => {}
    },
    weeklyReviewMode: {
      type: Boolean,
      default: () => false
    },
    monthChangeBtnControl: {
      type: Boolean,
      default: false   // not a function
    }

  },
  emits: ['update-month-year', 'show-register-view', 'update-selected-employee-type'],
  setup(props, context) {
    const store = useStore();
    const bSettings = store.getters['bSettings'];
    const gridApi = computed(() => {
      return store.getters['agGridModule/attendanceGridApi']
    })
    const label = ref(props?.currentFolder?.label?.eng);
    const isWeekPicker = ref(props.isDutyChart);
    const isRegisterView = computed(() => {
      return props.registerView;
    }
    );
    const currentViewFolder = ref(props.currentFolder)
    const gridView = ref(currentViewFolder?.value?.name);
    const isWeeklyReviewMode = computed(() => {
      return gridView.value === 'attendance' && !isRegisterView.value && props.weeklyReviewMode === true;
    });
    const isApprovalManager = ref(false);
    const isReportingManager = ref(true);
    const isAdmin = ref(false);
    const isPeUnapproveUser = ref(false);
    const showFilter = ref(true);
    const leaveQuota = ref({});
    const currentEmpCode = bSettings?.env?.code;
    if (bSettings?.env?.code === 'admin') {
      isApprovalManager.value = true;
      //isAdmin.value = true;
    } else if (bSettings?.env?.isAO) {
      isApprovalManager.value = true;
    } else if (bSettings?.env?.isRO) {
      isApprovalManager.value = true;
    } else if (bSettings?.env?.isHR) {
      isApprovalManager.value = true;
    }
    if (currentEmpCode === 'admin' || bSettings?.env?.isPE) {
      isApprovalManager.value = true;
      isAdmin.value = true;
    }
    const partnerGroups = Array.isArray(bSettings?.env?.partner_groups) ? bSettings.env.partner_groups : [];
    if (bSettings?.env?.isPE === true && partnerGroups.includes('pe')) {
      isPeUnapproveUser.value = true;
    }

    const { save, approveAttendance, rejectAttendance, unapproveAttendance, deficitMinutesToHours, convertUTCToISTDateTime } = attendanceGridUtils();
    const { saveAllocation, deleteAllocation } = allocationGridUtils();
    var firstLoad = true;
    async function saveChanges() {
      if (gridView.value === 'attendance') {
        if (isWeeklyReviewMode.value) {
          await props.saveWeeklySelection();
          return;
        }
        await save(store, isRegisterView.value, gridApi.value);
        await updateGetLeavesQuota();
        // await getLeavesQuota(selectedEmployee.value?.id, leaveQuotaInputDate);
      } else {
        await saveAllocation(store);
      }
    }

    async function deleteAllocations() {
      const cellsSelected = props.selectedCells;
      const selectedCells = await deleteAllocation(store, cellsSelected, gridApi.value);
      props.clearSelection(selectedCells);
    }

    function showInOut(event) {
      const isChecked = event.target.checked;
      props.showInOutToggle(isChecked);
    }

    function clearSelections() {
      if (isWeeklyReviewMode.value) {
        props.clearWeeklySelection();
        return;
      }
      props.clearSelection();
    }

    const removeEmptyRows = async() => {
      if (isWeeklyReviewMode.value) {
        toast.info('Remove row is unavailable in Weekly Review mode', {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      props.onGridReady();
    }

    const employeeContractsGetter = async(empid) => {
      if (empid != undefined) {
        try {
          const folderList = getAllFoldersList(bSettings);

          const txnParams = {
            filters: {
              filterInput: [
                {
                  path: 'employees.id',
                  operator: '=',
                  value: empid
                }
              ],
              joinop: 'and'
            },
            projections: {
              'employees': ['code', 'employee_contract', 'employee_type'],
              'employees.employee_contract': ['contract_range'],
              'employees.employee_type': ['code']
            }
          };

          const currFolder = getCurrentFolder('employees', folderList);

          const { listData } = postData();
          const data = await listData(currFolder, txnParams);

          if (!data || !data.output || !data.output.data || !data.output.data.records) {
            console.warn('No employee data found for employee ID:', empid);
            return [];
          }

          const { fatRowGenerator } = getFatRow();
          const finalData = fatRowGenerator(data);

          return finalData || [];
        } catch (error) {
          console.error('Error in contractsCalled:', error);
          return [];
        }
      }
      return [];
    };

    async function filterSelectedCells(cellData) {
      const data = JSON.parse(JSON.stringify(cellData));
      const contractRangeData = await contractRangeHandler();
      let retval;
      let showWarning = false;
      if (contractRangeData['0'] == 'NOT APPLIED') {
        retval = data;
      }
      else {
        contractRangeData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
        retval = data.map((d) => {
          Object.keys(d).forEach((dk) => {
            Object.keys(d[dk]).forEach((vk) => {
              let proceed = false;
              for (let i = 0; i < contractRangeData.length; i++) {
                const [start, end] = contractRangeData[i];

                let currDtMs;
                if (d[dk][vk].attendance_date.includes('T')) {
                  //if attendance_date has a value which has come from database, this is timezone aware and in correct format
                  currDtMs = new Date(d[dk][vk].attendance_date).getTime();
                }
                else {
                  //if attendance_date has a value which has just got created on client only, in this case date string has no timezone information so here, manually added 330 minutes
                  currDtMs = new Date(d[dk][vk].attendance_date).getTime() + 330 * 60 * 1000
                }

                if (currDtMs >= new Date(start).getTime() && currDtMs <= new Date(end).getTime()) {
                  proceed = true;
                  break;
                }
                else if (i == contractRangeData.length - 1) {
                  showWarning = true
                }
              }
              if (!proceed) {
                delete d[dk][vk];
              }
            });
          });
          return d;
        });
      }

      if (showWarning) {
        toast.warning('Some Rows can not be approved/settled as they do not fall under employee\'s contract range', {
          position: toast.POSITION.TOP_CENTER,
        });
        props.clearSelection([]);
      }

      return retval;
    }

    const approveAttendanceCells = async() => {
      if (isWeeklyReviewMode.value) {
        await props.approveWeeklySelection();
        return;
      }
      //let isDeficit = false;
      let deficitMinutes = 0;
      let isSP = false;
      const daysinMonth = attendanceRows.value.length;
      const cellsSelected = props.selectedCells;
      //let totalSelectedDays = 0;
      let approvedDays = 0;
      let approving = 0;
      for (let i = 0; i < daysinMonth; i++) {
        if (attendanceRows.value[i]?.attendance_status?.[0]?.code === 'unapproved') {
          const key = Object.keys(cellsSelected[0])
          const data = Object.keys(cellsSelected[0][key]);
          data.find((d) => {
            if (d == attendanceRows.value[i]?.day) {
              approving++;
            }
          })
        } else {
          approvedDays++;
        }
      }
      //for (let i = 0; i < attendanceRows.length; i++) {
      //  const key = Object.keys(cellsSelected[i]);
      //  for (let j = 0; j < key.length; j++) {
      //    totalSelectedDays += Object.keys(cellsSelected[i][key[j]]).length;
      //  }
      //}
      for (let i = 0; i < cellsSelected.length; i++) {
        const key = Object.keys(cellsSelected[i]);
        for (const obj in cellsSelected[i][key[0]]) {
          if (
            cellsSelected[i][key[0]][obj]?.difference < 0
          ) {
            //isDeficit = true;
            deficitMinutes += cellsSelected[i][key[0]][obj]?.difference;
          }
          if (cellsSelected[i][key[0]][obj]?.att_type?.[0]?.code === 'SP') {
            isSP = true;
          }
        }
      }
      if (isSP) {
        toast.warning('Single Punch cannot be approved', {
          position: toast.POSITION.TOP_CENTER,
        });
        props.clearSelection([]);
        return false;
      }
      if (isRegisterView.value && (approvedDays + approving) >= daysinMonth) {
        const element = document.getElementsByClassName('alert-window');
        element[0].style.display = 'block';
        const deficitElement = document.getElementById('deficit-hours');
        deficitElement.textContent = `Total deficit hours: ${deficitMinutesToHours(deficitMinutes, true)}`;
      } else {
        const selectedCells = [];
        //for (let i = 0; i < cellsSelected.length; i++) {
        // selectedEmployee.value = Object.keys(cellsSelected[i])[0];
        const filteredData = await filterSelectedCells(cellsSelected);
        const selectedCell = await approveAttendance(store, gridApi.value, filteredData, 'approve');
        selectedCells.push(selectedCell);
        //}
        props.clearSelection(selectedCells);
      }
      await updateGetLeavesQuota();
    }

    const rejectAttendanceCells = async() => {
      if (isWeeklyReviewMode.value) {
        await props.rejectWeeklySelection();
        return;
      }
      const cellsSelected = props.selectedCells;
      const selectedCells = await rejectAttendance(store, gridApi.value, cellsSelected);
      props.clearSelection(selectedCells);
      await updateGetLeavesQuota();
    }

    const unapproveAttendanceCells = async() => {
      if (isWeeklyReviewMode.value) {
        await props.unapproveWeeklySelection();
        return;
      }
      const cellsSelected = props.selectedCells;
      const selectedCells = await unapproveAttendance(store, gridApi.value, cellsSelected);
      props.clearSelection(selectedCells);
      await updateGetLeavesQuota();
    }


    async function contractRangeHandler() {
      try {
        let empId = selectedEmployee.value
        if (typeof (empId) == 'object' && empId.id != null) {
          empId = selectedEmployee.value.id
        }
        //console.log('selcted employee id: ', selectedEmployee.value);
        const selectedEmployeeContracts = await employeeContractsGetter(empId);
        if (!selectedEmployee.value || !selectedEmployee.value.id) {
          return ['NOT APPLIED'];
        }
        const selectedEmployeeContractsArray = [];

        const ddEmpTypes = ['outsourced', 'contractual', 'professional' ];

        //if (selectedEmployeeContracts?.length > 0 && ddEmpTypes.includes(selectedEmployeeContracts[0]['employee_type']['code'])) {
        if (selectedEmployeeContracts?.length > 0 && ddEmpTypes.includes(selectedEmployeeContracts[0].employee_type[0].code)) {

          if (selectedEmployeeContracts?.length > 0) {
            const employeeContracts = selectedEmployeeContracts[0].employee_contract || [];

            for (let i = 0; i < employeeContracts.length; i++) {
              const contractRange = employeeContracts[i].contract_range;

              // Fix JSON format and parse
              const data = JSON.parse(contractRange.replace(')', ']'));

              // Convert start date to IST
              const stDate = convertUTCToISTDateTime(data[0]);

              const edDateObj = new Date(convertUTCToISTDateTime(data[1]));
              edDateObj.setDate(edDateObj.getDate() - 1);

              data[0] = new Date(stDate);
              data[1] = new Date(edDateObj.toISOString());

              selectedEmployeeContractsArray.push(data);
            }
          }
        }
        else {
          //approval range for other employee need to varify
          selectedEmployeeContractsArray.push('NOT APPLIED');

        }

        return selectedEmployeeContractsArray;
      } catch (error) {
        console.error('Error in contractRangeHandler:', error);
        return [];
      }
    }


    async function updateGetLeavesQuota() {
      try {
        if (!selectedEmployee.value || !selectedEmployee.value.id) {
          return;
        }
        const lastDayOfMonth = new Date(monthYear.value?.year, monthYear.value?.month, 0);
        const contractRangeData = await contractRangeHandler();
        const currentContract = ref('');

        console.log('UpdatedSelectedEmployee', selectedEmployee, contractRangeData, lastDayOfMonth);

        if (contractRangeData.length > 0) {
          let found = false;

          contractRangeData.sort((a, b) => new Date(a[0]) - new Date(b[0]));

          for (let i = 0; i < contractRangeData.length; i++) {
            const [stDateStr, edDateStr] = contractRangeData[i];

            const stDate = new Date(stDateStr);
            const edDate = new Date(edDateStr);

            if (lastDayOfMonth >= stDate && lastDayOfMonth <= edDate) {
              currentContract.value = lastDayOfMonth;
              found = true;
              break;
            }
          }

          if (!found) {
            const lastContract = contractRangeData[contractRangeData.length - 1];
            const lastEndDate = new Date(lastContract[1]);

            if (
              lastEndDate.getFullYear() === lastDayOfMonth.getFullYear() &&
        lastEndDate.getMonth() === lastDayOfMonth.getMonth() &&
        lastEndDate.getDate() < lastDayOfMonth.getDate()
            ) {
              currentContract.value = lastEndDate;
            } else {
              currentContract.value = lastDayOfMonth;
            }
          }
        }
        getLeavesQuota(selectedEmployee.value?.id, currentContract);
      }
      catch (err) {
        console.error('Error in updateGetLeavesQuota', err);
      }
    }


    async function updateMonthYear(inputMonthYear) {
      monthYear.value = inputMonthYear;
      context.emit('update-month-year', inputMonthYear)
      // const lastDayOfMonth = new Date(inputMonthYear.year, inputMonthYear.month, 0)
      // leaveQuotaInputDate = lastDayOfMonth.toISOString()
      // await getLeavesQuota(selectedEmployee.value?.id, leaveQuotaInputDate)
      await updateGetLeavesQuota();
    }

    function showRegisterView(event) {
      context.emit('show-register-view', event.target.checked)
    }

    //Register view

    const attendanceRows = computed(() => {
      return store.getters['agGridModule/attendanceGridRows'];
    });


    const searchQuery = ref('');
    const selectedEmployeeType = ref();
    const selectedEmployee = ref();
    const monthYear = ref();
    const showPendingOnly = ref(true);
    const showApprovedOnly = ref(false);
    function updateSearchQuery(query) {
      searchQuery.value = query;
    }
    async function updateSelectedEmployee(employee) {
      selectedEmployee.value = employee;
      console.log('selcted employee id: ', selectedEmployee.value);
      await updateGetLeavesQuota();
      // await getLeavesQuota(employee.id, leaveQuotaInputDate);
    }
    const { getAllFoldersList, getCurrentFolder } = getFolders();
    async function getLeavesQuota(empId, inputDate) {
      try {
        const currentEmp = empId
        const folderList = getAllFoldersList(bSettings);
        const leavesFolder = getCurrentFolder('leaves', folderList);
        const txnToGetLeaveQuota = leavesFolder?.txns?.txn_show_leaves_quota
        const txnParams = { 'refRows': true, 'employees_id': currentEmp, 'input_date': inputDate}
        txnToGetLeaveQuota.params = txnParams
        const result = await sendMessage(txnToGetLeaveQuota)
        if (result?.output?.data?.records?.[0]) {
          leaveQuota.value = JSON.parse(result.output.data?.records?.[0])
          console.log('LeaveQuota value', leaveQuota.value);
          store.commit('commonModule/leavesQuotaMutations', leaveQuota.value)
        }
      } catch (error) {
        console.log(error)
      }
    }
    function makeEmployeeValue(emp) {
      return {
        label: `${emp.name} (${emp.empCode}) - ${emp.empType} - ${emp.designation} - RO: ${emp.roName} (${emp.roEmpCode})`,
        id: emp.id,
        type: emp.empType,
        designation: emp.designation,
        roName: emp.roName,
        roEmpCode: emp.roEmpCode
      }
    }
    function resetSelectedEmployee() {
      console.log('tools', filteredAttendanceSummary.value)
      const emp = filteredAttendanceSummary.value[0]
      if (emp != null) {
        // selectedValue signature copied from EmployeeFilter
        // TODO : a standard docpicker control and selected value signature ...
        const selectedValue = makeEmployeeValue(emp)
        updateSelectedEmployee(selectedValue)
      }
    }
    function updateSelectedEmployeeType(employeeType) {
      selectedEmployeeType.value = employeeType;
      context.emit('update-selected-employee-type', employeeType);
      resetSelectedEmployee();
    }
    function togglePendingWork(pendingValue, approvedValue) {
      showPendingOnly.value = pendingValue;
      showApprovedOnly.value = approvedValue;
      resetSelectedEmployee();
    }
    function toggleApprovedWork(approvedValue, pendingValue) {
      showApprovedOnly.value = approvedValue;
      showPendingOnly.value = pendingValue;
      resetSelectedEmployee();
    }
    /*const attendanceSummary = computed(() => {
      const attStatus = [];
      for (let i = 0; i < attendanceRows.value?.attStatus?.length; i++) {
        let missedPunch = attendanceRows.value.length;
        for (let j = 0; j < attendanceRows.value.attStatus[i]?.data?.info?.length; j++) {
          const keys = Object.keys(attendanceRows.value.attStatus[i]?.data?.info[j]);
          if (attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[keys[0]] !== 0) {
          }
          missedPunch = missedPunch - attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[keys[0]];
        }
        for (let j = 0; j < attendanceRows.value.attStatus[i]?.data?.info?.length; j++) {
          const keys = Object.keys(attendanceRows.value.attStatus[i]?.data?.info[j]);
          if (keys[0] === 'unapproved') {
            missedPunch += attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[keys[0]];
            attStatus.push({
              empCode: attendanceRows.value.attStatus[i]?.data?.emp_code,
              empType: attendanceRows.value.attStatus[i]?.data?.employee_type?.eng,
              name: attendanceRows.value.attStatus[i]?.data?.first_name?.eng + ' ' +  (attendanceRows.value.attStatus[i]?.data?.last_name?.eng || ''),
              unapproved: attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[keys[0]] !== 0 ? missedPunch : '-',
              id: attendanceRows.value.attStatus[i]?.data.emp_id
            })
          }
        }
      }
      return attStatus;
    })*/
    const attendanceSummary = computed(() => {
      const empWiseAttStatus = [];
      const total = attendanceRows.value?.length || 0;
      for (let i = 0; i < attendanceRows.value?.attStatus?.length; i++) {

        const obj = {
          empCode: attendanceRows.value.attStatus[i]?.data?.emp_code,
          empType: attendanceRows.value.attStatus[i]?.data?.employee_type?.eng,
          designation: attendanceRows.value.attStatus[i]?.data?.designation,
          name: attendanceRows.value.attStatus[i]?.data?.first_name?.eng + ' ' +  (attendanceRows.value.attStatus[i]?.data?.last_name?.eng || ''),
          id: attendanceRows.value.attStatus[i]?.data.emp_id
        }
        const first = attendanceRows.value.attStatus[i]?.data?.ro_first_name?.eng ?? '';
        const last = attendanceRows.value.attStatus[i]?.data?.ro_last_name?.eng ?? '';
        const roName = first ? `${first} ${last}`.trim() : '';
        const roEmpCode = attendanceRows.value.attStatus[i]?.data?.ro_emp_code ?? '';
        obj.roName = roName;
        obj.roEmpCode = roEmpCode;
        for (let j = 0; j < attendanceRows.value.attStatus[i]?.data?.info?.length; j++) {
          const attStatus = Object.keys(attendanceRows.value.attStatus[i]?.data?.info[j])[0];
          if (attStatus == 'unapproved') {
            obj.final_approved = obj.final_approved != null ? obj.final_approved : 0;
            obj.attendanceExists = attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[attStatus] > 0;
          }
          else if (attStatus == 'final_approved' || attStatus == 'intermediate_approved') {
            const approvedCount = attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[attStatus];
            obj.final_approved = obj.final_approved != null ? obj.final_approved + approvedCount : approvedCount;
          }
          else if (attStatus == 'settled') {
            const settledCount = attendanceRows.value.attStatus[i]?.data?.info?.[j]?.[attStatus];
            obj.final_approved = obj.final_approved != null ? obj.final_approved + settledCount : settledCount;
          }
          else {
            obj.attendanceExists = true;
          }
        }
        obj.unapproved = total - (obj.final_approved || 0);
        obj.fully_approved = obj.final_approved == total;
        obj.empDesignation = attendanceRows?.value?.employees?.designation?.[0]?.name ?? '';
        empWiseAttStatus.push(obj);
      }
      return empWiseAttStatus;
    })


    /*const filteredAttendanceSummary = computed(() => {
      const search = searchQuery.value.toLowerCase();
      return attendanceSummary.value.filter((status) => {
        const name = status.name.toLowerCase();
        const empCode = status.empCode.toLowerCase();

        // Filter by search query and unapproved status based on the "Show Pending Work" button
        const matchesSearch = name.includes(search) || empCode.includes(search);
        const matchesUnapprovedFilter = showPendingOnly.value ? status.unapproved > 0 : true;
        return matchesSearch && matchesUnapprovedFilter;
      });
    });*/

    const filteredAttendanceSummary = computed(() => {
      const search = searchQuery.value.toLowerCase();
      const result =  attendanceSummary.value.filter((status) => {
        const name = status.name.toLowerCase();
        const empCode = status.empCode.toLowerCase();
        const empType = status.empType != null  ? status.empType.toLowerCase() : ''
        // Filter by search query and unapproved status based on the "Show Pending Work" button
        const matchesSearch = name.includes(search) || empCode.includes(search);
        const matchesType = selectedEmployeeType.value != '' && selectedEmployeeType.value != null ?  selectedEmployeeType.value.toLowerCase() == empType : true
        let matchesUnapprovedFilter = true;
        if (showPendingOnly.value) {
          matchesUnapprovedFilter = status.unapproved > 0 || status.attendanceExists == true;
        }
        else if (showApprovedOnly.value) {
          matchesUnapprovedFilter = status.fully_approved == true;
        }
        return matchesSearch && matchesType && matchesUnapprovedFilter;
      });
      return result
    });
    watch(filteredAttendanceSummary, (newVal) => {
      if (newVal.length > 0 && firstLoad) {
        setTimeout(resetSelectedEmployee, 200);
        firstLoad = false;
      }
    });

    const allowRowRemove = computed(() => {
      let retval = true;
      const bSettings = store.getters['bSettings'];
      const env = bSettings.env;
      const selectedSWHandle = store.getters['userModule/selectedPartner'];
      const loggedInSWHandle = env.swhandle

      if (loggedInSWHandle != selectedSWHandle) {
        retval = false;
      }
      return retval;
    })

    // expose the method(s) to parent refs
    context.expose({ filterSelectedCells });

    return {
      label,
      gridView,
      isWeekPicker,
      isRegisterView,
      showRegisterView,
      currentViewFolder,
      updateMonthYear,
      isAdmin,
      showInOut,
      isApprovalManager,
      isReportingManager,
      isPeUnapproveUser,
      showFilter,
      leaveQuota,
      saveChanges,
      removeEmptyRows,
      approveAttendanceCells,
      rejectAttendanceCells,
      unapproveAttendanceCells,
      clearSelections,
      deleteAllocations,
      filteredAttendanceSummary,
      togglePendingWork,
      toggleApprovedWork,
      showApprovedOnly,
      showPendingOnly,
      selectedEmployee,
      selectedEmployeeType,
      updateSelectedEmployeeType,
      updateSearchQuery,
      updateSelectedEmployee,
      allowRowRemove,
    };
  }
};
</script>

<style>
.business-filter .vs--single .vs__selected{
margin: 0px;
}
.custom-header {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.right-position {
  position: absolute !important;
  left: 80vw;
  top: 11vh;
  width: 300px;
}

.custom-header div {
  cursor: pointer;
  position: relative;
}

.vs__selected{
  margin:0px;
}
.custom-header span {
  font-size: 20px;
  color: #292929;
  margin: 10px;
}
.businesses-filter{
  width: 160px;
}
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin: 10px;
}

.filter-icon {
  cursor: pointer;
  background-color: #aebbcc;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
}

.filter-icon:hover {
  background-color: #83ACC8;
}

.action-container {
  display: flex;
  align-items: center;
  color: #292929;
}

.action-button {
  background-color: #aebbcc;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  text-wrap: nowrap;
  cursor: pointer;
}

.action-button:hover {
  background-color: #83ACC8;
}

.action-save {
  background-color: #aebbcc;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
}

.action-save:hover {
  background-color: #83ACC8;
}

</style>
